import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";

const AlertBox = (props) => {
  return (
    <Modal
      isOpen={props.alertVisibility}
      onRequestClose={props.closeAlertBoxHandler}
      style={props.alertStyle}
      shouldCloseOnOverlayClick={props.backdrop}
      contentLabel={props.alertLabel}
      className={props.alertClass}
    >
      {props.children}
    </Modal>
  );
};

AlertBox.propTypes = {
  alertVisibility: PropTypes.bool,
  backdrop: PropTypes.bool,
  alertLabel: PropTypes.string,
  closeAlertBoxHandler: PropTypes.func,
};

export default AlertBox;



// WEBPACK FOOTER //
// ./src/components/common/UI/AlertBox/AlertBox.js